export const PREPROJETO_STORE = 'preprojeto';